import {CurationDashboardOperations} from "./curation-dashboard-interface";
import {IcurationWorklistItem} from "../../../interfaces/curation-worklist-item.interface";
import {IoptionElemet} from "@ispm/shared/interfaces/IoptionElemet";
import {Inject, Injectable} from "@angular/core";
import {CurationActionCreatorService} from "../../../services/curation-action-creator.service";
import {AddCurationComponent} from "../../add-curation/add-curation.component";
import {CurationUtils} from "../../../utils/curation-utils";
import {get, has, set} from 'lodash';
import { AuthenticationService } from "@ispm/user/services/authentication.service";

@Injectable()
export class curationDashboardPlacementService implements CurationDashboardOperations {

  constructor(private curationActionCreatorService: CurationActionCreatorService,
              private authService: AuthenticationService) {
  }

  adaptDataToGrid(item: IcurationWorklistItem, currentConf: any, currentUserOrgId: string) {
    CurationUtils.adaptCurationDataToGrid(item, currentConf, currentUserOrgId);
  }

  adaptDataToGridWithGrantedAction(item: IcurationWorklistItem, currentUserOrgId: string, actionGrantedForType: boolean) {
    CurationUtils.adaptDataToGridWithGrantedAction(item, currentUserOrgId, actionGrantedForType);
  }

  loadAddItemOptions(conf: any, newItemOptions: any[], curationTypeByFormName: Map<string, any>, loadFormFunc: any, context) {
  }

  getAddButtonName() {
    return 'Add new placement';
  }

  createCurationItem(curationToCreate: any) {
    return this.curationActionCreatorService.createCurationItemV1(curationToCreate);
  }

  getCloningEnabled(): boolean {
    return true;
  }

  getCurationCreationData(itemData: { type: string; inputs: IoptionElemet[] }, formName: string) {
    let payload = {formName: formName}
    return {createComp: AddCurationComponent, payload: payload}
  }

  prepareCurationItem(model: any, curationType: string) {
    delete model['dummy'];
    model.type = curationType;
    return {
      'content': model,
      'opinion': CurationUtils.buildOpinion(this.authService.user),
    };
  }

  getCurationItem(curationItemId, revisionId, type) {
    return this.curationActionCreatorService.getCurationItemV1(curationItemId, revisionId, type);
  }

  getCurationItemByKeys(curationToCreate: any, forCurrentOrg: boolean = false, additionalValidationSet?: string[]) {
    return this.curationActionCreatorService.getCurationItemByKeysV1(curationToCreate, forCurrentOrg);
  }

  getMockList() {
  }

  openEditorParams(response: any) {
    return {
      curationId: response.curationItem.id,
      wfId: response.curationItem.workflowRequestId,
      revisionId: response.curationData.revisionId,
      curationType: response.curationItem.type
    };
  }

  updateDataFromModel(form: any, content: any, isClonedFromAnotherOrg: boolean, grantedActionsTable?:any) {
    set(content, 'placementName', form['placementName']);
    set(content, 'nodes', []);
    set(content, 'pathway', form['pathway']);
    set(content, 'disease.code', get(form,'pathway.diseaseCode'));
    set(content, 'disease.display', get(form,'pathway.diseaseDisplay') || get(form,'disease.display'));

  }
}
